import {RouterProps} from "./RouterProps";

export default function HomePage(props: RouterProps) {
    return <>HomePage</>
}